var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcTittleSubzone(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.66407 13C10.4255 13 12.6641 10.7614 12.6641 8C12.6641 5.23858 10.4255 3 7.66407 3C4.90264 3 2.66407 5.23858 2.66407 8C2.66407 10.7614 4.90264 13 7.66407 13Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.66407 15C6.2796 15 4.92622 14.5895 3.77507 13.8203C2.62393 13.0511 1.72672 11.9579 1.19691 10.6788C0.667095 9.3997 0.528472 7.99224 0.798569 6.63437C1.06867 5.2765 1.73535 4.02922 2.71432 3.05026C3.69329 2.07129 4.94057 1.4046 6.29843 1.13451C7.6563 0.86441 9.06377 1.00303 10.3428 1.53285C11.6219 2.06266 12.7152 2.95987 13.4844 4.11101C14.2535 5.26216 14.6641 6.61553 14.6641 8C14.662 9.85588 13.9238 11.6351 12.6115 12.9474C11.2992 14.2597 9.51994 14.9979 7.66407 15ZM7.66407 2C6.47738 2 5.31734 2.3519 4.33064 3.01119C3.34395 3.67047 2.57491 4.60755 2.12079 5.7039C1.66666 6.80026 1.54784 8.00666 1.77935 9.17054C2.01087 10.3344 2.58231 11.4035 3.42142 12.2426C4.26054 13.0818 5.32964 13.6532 6.49352 13.8847C7.65741 14.1162 8.86381 13.9974 9.96017 13.5433C11.0565 13.0892 11.9936 12.3201 12.6529 11.3334C13.3122 10.3467 13.6641 9.18669 13.6641 8C13.6623 6.40926 13.0295 4.88419 11.9047 3.75936C10.7799 2.63454 9.25481 2.00182 7.66407 2Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcTittleSubzone);
export default __webpack_public_path__ + "static/media/ic-tittle-subzone.242f81fd9e74b03347f29c029097326e.svg";
export { ForwardRef as ReactComponent };